function extractFilters(response: any) {
  return {
    platform_id: response.platform_id || {},
    platform: response.platform || {},
    type: response.type || {},
    status: response.status || {},
    school_id: response.school_id || {},
    round_id: response.round_id || {},
    round: response.round || {},
    grade_id: response.grade_id || {},
    academic_year: response.academic_year || {},
  };
}
export default extractFilters;
